import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AxelInput from "../../../UI/AxelInput";
import AxelCheckbox from "../../../UI/AxelCheckbox";
import {
    useCreateUsersMutation,
    useLazyGetAllProjectsQuery,
    useUpdateUsersMutation
} from "../../../store/service/adbService";
import {toast} from "react-toastify";
import {errorHandle} from "../../../global/errorHandle";
import {setLoader} from "../../../store/slice/dashboard";
import {useDispatch} from "react-redux";

const CreateUser2 = () => {
    const { id: userId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isCreateUserPage = location.pathname === "/create-user/step-2";
    const storageKey = isCreateUserPage ? "create-user" : "edit-user";
    const storedData = JSON.parse(localStorage.getItem(storageKey)) || {};
    const [searchText, setSearchText] = useState("");
    const [allSelected, setAllSelected] = useState(false);
    const [selectedProjects, setSelectedProjects] = useState(storedData?.projects || []);
    const [projects, setProjects] = useState([]);
    const [getAllProjects] = useLazyGetAllProjectsQuery();
    const [createUsers, { isSuccess: isCreateSuccess, isError: isCreateError, error: createError }] =
        useCreateUsersMutation();
    const [updateUsers, { isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError }] =
        useUpdateUsersMutation();

    useEffect(() => {
        getAllProjects({ per_page: 1000, page: 1 }).then(({ data }) => {
            setProjects(data?.data?.data || []);
        });
    }, [getAllProjects]);

    useEffect(() => {
        setAllSelected(selectedProjects.length === projects.length);
    }, [selectedProjects, projects]);


    useEffect(() => {
        // Needed fixing
        if (isCreateSuccess) {
            toast.success("User created successfully!");
            localStorage.removeItem(storageKey);
            navigate('/secondary-pages/users')
        }
        if (isUpdateSuccess) {
            toast.success("User updated successfully!");
            localStorage.removeItem(storageKey);
            navigate('/secondary-pages/users')
        }

    }, [isCreateSuccess, isUpdateSuccess]);

    useEffect(() => {
        if (isCreateError) errorHandle(createError);
        if (isUpdateError) errorHandle(updateError);
        dispatch(setLoader(false));
    }, [ isCreateError, isUpdateError, createError, updateError]);

    useEffect(() => {
        dispatch(setLoader(isCreateSuccess || isUpdateSuccess));
    }, [isCreateSuccess, isUpdateSuccess, dispatch]);


    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = { projects: selectedProjects };
        dispatch(setLoader(true));
        if (userId) {
            updateUsers({ id: userId, body: {
                    ...storedData,
                    ...formData } });
        } else {
            createUsers({ ...storedData, ...formData });
        }

    };
    const handleSelectAll = (isSelected) => {
        setAllSelected(isSelected);
        setSelectedProjects(isSelected ? projects.map((project) => project.id) : []);
    };

    const handleSelection = (projectId) => {
        setSelectedProjects((prevSelected) =>
            prevSelected.includes(projectId)
                ? prevSelected.filter((id) => id !== projectId)
                : [...prevSelected, projectId]
        );
    };

    const filteredProjects = projects.filter((project) => {
        const search = searchText.toLowerCase();
        return (
            project.project_name?.toLowerCase().includes(search) ||
            project.contract_number?.toLowerCase().includes(search)
        );
    });

    const handleNavigation = (path) => (e) => {
        e.preventDefault();
        localStorage.setItem(
            storageKey,
            JSON.stringify({ ...storedData, projects: selectedProjects })
        );
        navigate(path);
    };

    return (
        <form className="create__form"  onSubmit={handleSubmit}>
            <div className="create__form-content">
                <AxelInput
                    className="nSettings__copySettings__search searchProject"
                    src="/assets/icons/search.svg"
                    placeholder="Search..."
                    value={searchText}
                    handler={(e) => setSearchText(e.target.value)}
                />
                <div className="contact__modal-projectBox">
                    <AxelCheckbox
                        id="all-projects"
                        checked={allSelected}
                        handler={(e, isChecked) => handleSelectAll(isChecked)}
                    />
                    <label htmlFor="all-projects">Select all projects</label>
                </div>
                {filteredProjects.map((project) => (
                    <div key={project.id} className="contact__modal-projectBox">
                        <AxelCheckbox
                            id={`project-${project.id}`}
                            checked={selectedProjects.includes(project.id)}
                            handler={() => handleSelection(project.id)}
                        />
                        <label htmlFor={`project-${project.id}`}>
                            {project.project_name} - {project.contract_number}
                        </label>
                    </div>
                ))}
            </div>
            <div className="create__form-btns">
                <button
                    type="button"
                    onClick={handleNavigation(isCreateUserPage ? "/create-user/step-1" : `/edit-user/${userId}/step-1`)}
                    className="create__form-back"
                >
                    Back
                </button>
                <button
                    type="submit"
                    // onClick={handleNavigation(isCreateUserPage ? "/create-user/step-3" : `/edit-user/${userId}/step-3`)}
                    className="create__form-next"
                >
                    <span>Save</span>
                    <span>
                        <img src="/assets/icons/next-icon.svg" alt="icon" />
                    </span>
                </button>
            </div>
        </form>
    );
};

export default CreateUser2;
